var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useEffect } from 'react';
import { classNames } from '../../utils/style-class.utils';
import * as styles from './slider-pagination.styles';
export var SliderPagination = function (_a) {
    var totalItems = _a.totalItems, activeIndex = _a.activeIndex, className = _a.className;
    var _b = useState([]), paginationItems = _b[0], setPaginationItems = _b[1];
    var generateArray = function (total) {
        var items = [];
        for (var i = 0; i < total; i++) {
            items.push(i);
        }
        return items;
    };
    useEffect(function () {
        var items = generateArray(totalItems);
        setPaginationItems(items);
    }, [totalItems]);
    return (_jsx("div", __assign({ className: classNames(styles.wrapper, className) }, { children: paginationItems &&
            paginationItems.map(function (value, index) { return (_jsx("div", { "data-testid": "pagination-item-".concat(index), className: index < activeIndex
                    ? styles.visitedItem
                    : index === activeIndex
                        ? styles.activePaginationItem
                        : styles.paginationItem }, "pagination-item-".concat(index))); }) })));
};
export default SliderPagination;
//# sourceMappingURL=slider-pagination.js.map